import { FC } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'

import { PatientRelativeForm, PatientRelativeFormProps } from '../PatientRelativeForm/PatientRelativeForm'

type Props = Omit<PatientRelativeFormProps, 'onCancel'> & {
  title: React.ReactNode
  show: boolean
  onHide: () => void
}

const PatientRelativeFormDrawer: FC<Props> = ({ title, show, onHide, ...formProps }) => {
  return (
    <Offcanvas
      placement="end"
      show={show}
      onHide={onHide}
      style={{ width: '50vw' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="h3">{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <PatientRelativeForm
          {...formProps}
          onCancel={onHide}
        />
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export { PatientRelativeFormDrawer }
